import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaChevronLeft } from 'react-icons/fa';
import { InvoiceData } from '../../../types/payments';
import Button from '../../components/buttons/Button';
import InvoicesTable from '../../components/tables/InvoicesTable';
import { subscriptionService } from '../../../services/community/subscriptionService';
import { businessSubscriptionService } from '../../../services/business/subscriptionService';

export default function InvoicesPage(): JSX.Element {
  const { t } = useTranslation('', { keyPrefix: 'page.invoices' });
  const [invoices, setInvoices] = React.useState<InvoiceData[]>([]);
  const [loading, setLoading] = React.useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  const isBusiness =
    location.pathname.includes('/business') || Boolean(location.state?.isBusiness);
  const service = isBusiness ? businessSubscriptionService : subscriptionService;
  const backRoute = isBusiness ? '/business/subscription' : '/subscription/manage';

  useEffect(() => {
    service
      .getLastInvoices(Number.MAX_SAFE_INTEGER)
      .then(setInvoices)
      .catch(() => {
        console.error('No invoices found');
      })
      .finally(() => setLoading(false));
  }, [service]);

  return (
    <>
      <div>
        <div className="flex flex-col gap-2">
          <Button className="p-0 text-sm" onClick={() => navigate(backRoute)}>
            <FaChevronLeft /> {t('toManagePage')}
          </Button>
          <div className="flex items-center gap-4">
            <h2 className="text-2xl">{t('title')}</h2>
          </div>
          <p className="w-1/3 text-gray-500">{t('subtitle')}</p>
        </div>
      </div>
      <InvoicesTable invoices={invoices} loading={loading} />
    </>
  );
}
